export default __webpack_public_path__ + "static/media/placeholder_business04-nl-mobile.77f43386.png";